import 'core-js';
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import "core-js/modules/es6.array.iterator.js"
import "core-js/modules/es6.array.from"
import Vue from 'vue';
import IdleVue from 'idle-vue'
import router from './router';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import store from './store';
import axios from 'axios';
import i18n from './plugins/i18n';
import BootstrapVue from 'bootstrap-vue';import Vuebar from 'vuebar';
import Cleave from 'vue-cleave-component';

//KB47296 Start
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

const globalOptions = {
  defaultCountry: 52,
  autoFormat: false,
  inputOptions:{
    placeholder: '10 dígitos',
    maxlength: 14,
    required: true,
    autocomplete: 'off',
  },
  preferredCountries:['MX','US'],
  ignoredCountries:['as','ai','ag','bs','bb','bm','vg','ky','dm','gd','gu','jm','ms','mp','kn','lc','vc','tt','tc','vi']
};
//KB47296 End

/**
 * vue analytics - google analytics
 */
/**
 import VueAnalytics from 'vue-analytics';
 Vue.use(VueAnalytics, {
   id: process.env.VUE_APP_IDGOOGLEANALYTICS,
   router
 });
 */
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1500000
})
Vue.use(Vuebar);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(Cleave);
//KB47296 Start
Vue.use(VueTelInput, globalOptions);
//KB47296 End
Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_UAT;

Vue.directive('click-outside', {
  bind: function(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) { warn += `Found in component '${compName}'` }
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
          binding.value(e);
      }
    }
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function(el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
});


  Vue.directive("uppercase", {
    twoWay: true,
    // TODO: unbind
    unbind: () => {},
    bind: function (el, binding, vnode) {
      const findVModelName = vnode => {
        try {
          // https://forum.vuejs.org/t/solved-how-can-you-update-the-v-model-from-a-custom-directive-in-vue-2/2275
          return vnode.data.directives.find(o => {
            return o.name === "model";
          }).expression;
        } catch (error) {
          error.message = `Unable to find v-model directive at ${
          vnode.tag
        } tag. Please specify the expression: v-uppercase='obj.prop'`;
          throw error;
        }
      };

      const funcByName = (functionName, context, value) => {
        // https://stackoverflow.com/a/359910/8801075
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++)
          context = context[namespaces[i]];
        return (context[func] = value);
      };

      var expression = binding.expression ?
        binding.expression :
        findVModelName(vnode);
      vnode.context.$watch(expression, {
        //deep: true, // ?
        immediate: true,
        handler(newVal) {
          if (newVal) {
            return funcByName(
              expression,
              vnode.context,
              newVal.toString().toLocaleUpperCase()
            );
          }
        }
      });
    }
  });

  Vue.directive("lowercase", {
    twoWay: true,
    // TODO: unbind
    unbind: () => {},
    bind: function (el, binding, vnode) {
      const findVModelName = vnode => {
        try {
          // https://forum.vuejs.org/t/solved-how-can-you-update-the-v-model-from-a-custom-directive-in-vue-2/2275
          return vnode.data.directives.find(o => {
            return o.name === "model";
          }).expression;
        } catch (error) {
          error.message = `Unable to find v-model directive at ${
          vnode.tag
        } tag. Please specify the expression: v-uppercase='obj.prop'`;
          throw error;
        }
      };
  
      const funcByName = (functionName, context, value) => {
        // https://stackoverflow.com/a/359910/8801075
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++)
          context = context[namespaces[i]];
        return (context[func] = value);
      };
  
      var expression = binding.expression ?
        binding.expression :
        findVModelName(vnode);
      vnode.context.$watch(expression, {
        //deep: true, // ?
        immediate: true,
        handler(newVal) {
          if (newVal) {
            return funcByName(
              expression,
              vnode.context,
              newVal.toString().toLocaleLowerCase()
            );
          }
        }
      });
    }
  });

  Vue.directive('onlyText', {
    update: function(el) {
      el.value = el.value.replace(/[^A-Za-zÑñ\s\u007FáéíóúüñÁÉÍÓÚÜÑ]+/, '');
    }
  });

  Vue.directive('alphanumeric', {
      update: function(el) {
        el.value = el.value.replace(/[^a-zA-Z0-9]/g, '');
      }
  });

  Vue.directive('alphanumericAddress', {
      update: function(el) {
        el.value = el.value.replace(/[^a-zA-Z0-9 .,]/g, '');
      }
  });

  Vue.directive('onlyNumbers', {
      bind(el, binding, vnode) {
        let handlerInput = (e) => {
          const hasNumberRgx = /^[0-9]*$/;
          const numberRgx = /[^0-9]/g;
          if (hasNumberRgx.test(e.target.value) === false) {
            const start = e.target.selectionStart;
            const end = e.target.selectionEnd;
            e.target.value = e.target.value.replace(numberRgx, '');
            e.target.setSelectionRange(start, end);
            e.target.dispatchEvent(new CustomEvent('input'))
          }
        };
        el.addEventListener('input', handlerInput);
      }
  });


  Vue.directive('email', {
    update: function(el) {
      el.value = el.value.replace(/[^a-zA-Z0-9.-_-\-@]/g, '');
    }
  });

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
